import React, { ReactElement } from 'react'
import { makeStyles, Grid } from '@material-ui/core';

import KTR700 from './Clampexsets/KTR700';
import KTR603 from './Clampexsets/KTR603';
import KTR620 from './Clampexsets/KTR620';
import KTR150 from './Clampexsets/KTR150';
import KTR100 from './Clampexsets/KTR100';
import KTR201 from './Clampexsets/KTR201';
import KTR206 from './Clampexsets/KTR206';
import KTR225 from './Clampexsets/KTR225';
import KTR250 from './Clampexsets/KTR250';
import KTR130 from './Clampexsets/KTR130';
import KTR131 from './Clampexsets/KTR131';
import KTR105 from './Clampexsets/KTR105';
import KTR203 from './Clampexsets/KTR203';
import KTR200 from './Clampexsets/KTR200';
import KTR400 from './Clampexsets/KTR400';
import { useIntl } from 'react-intl';

const useStyle = makeStyles({
    card:{
        margin: "10px",
    },
    cardRow2:{
        margin: "10px",
        height: "360px",
    },
    cardRow3:{
        margin: "10px",
        height: "340px"
    },
    cardRow4:{
        margin: "10px",
        height: "370px"
    },
    cardRow5:{
        margin: "10px",
        height: "370px"
    }
});

export default function ProductsOverview(): ReactElement {
    
    let classes = useStyle();
      

    const { formatMessage: f } = useIntl();
    

    return (
        <Grid>
            <h2>{f({id: 'app.direct.insideclamping'})}</h2>
            <Grid style={{ marginTop: "20px" }} container justify="center">
                <Grid item>
                    <KTR100 className={classes.card}/>
                </Grid>
                <Grid item>
                    <KTR105 style={{height: "343px"}} className={classes.card}/>
                </Grid>
            </Grid>
            <Grid style={{ marginTop: "20px" }} container justify="center">
                <Grid item>
                    <KTR130 className={classes.cardRow2}/>
                </Grid>
                <Grid item>
                    <KTR131 className={classes.cardRow2}/>
                </Grid>
                <Grid item>
                    <KTR150 className={classes.cardRow2}/>
                </Grid>
            </Grid>
            <Grid style={{ marginTop: "20px" }} container justify="center">
                <Grid item>
                    <KTR200 className={classes.cardRow3}/>
                </Grid>
                <Grid item>
                    <KTR201 className={classes.cardRow3}/>
                </Grid>
                <Grid item>
                    <KTR203 className={classes.cardRow3}/>
                </Grid>
            </Grid>
            <Grid style={{ marginTop: "20px" }} container justify="center">
                <Grid item>
                    <KTR206 className={classes.cardRow4}/>
                </Grid>
                <Grid item>
                    <KTR225 className={classes.cardRow4}/>
                </Grid>
                <Grid item>
                    <KTR250 className={classes.cardRow4}/>
                </Grid>
            </Grid>
            <Grid style={{ marginTop: "20px" }} container justify="center">
                <Grid item>
                    <KTR400 className={classes.card}/>
                </Grid>
            </Grid>
            <h2>{f({id: 'app.direct.outsideclamping'})}</h2>
            <Grid style={{ marginTop: "20px" }} container justify="center">
                <Grid item>
                    <KTR603 className={classes.card}/>
                </Grid>
                <Grid item>
                    <KTR620 className={classes.card}/>
                </Grid>
            </Grid>
            <h2>{f({id: 'app.direct.shaftcoupling'})}</h2>
            <Grid style={{ marginTop: "20px" }} container justify="center">
                <Grid item>
                    <KTR700 className={classes.card}/>
                </Grid>
                <Grid item>
                </Grid>
            </Grid>
        </Grid>
    )
}
